import "../css-source/site.scss";

import { accordion } from "./accordion";
import { booklist } from "./book_list";
import { nav } from "./nav";
import { catnav } from "./category_nav";
import { truncate } from "./truncate";

// booklist.init();
nav.init();
catnav.init();
truncate.init();
accordion.init(".Accordion", { header_class: "Accordion__header__button" });

// Enable parcel HMR
if (module.hot) {
    module.hot.accept();
}

// console.log("running site js...");
